export const getNonObliqueHeadCellSx = (headerHeight = 130) => ({
	height: headerHeight,
	"& .Mui-TableHeadCell-Content": {
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-end",
		height: "100%",
	},
});

export const buildObliqueColumnMeta = (label, width = 140, options = {}) => {
	const {
		headSx = {},
		bodySx = {},
		headerHeight = 130,
		enableHeadFlex = false,
		rotationAngle = -55,
		contentLabelsPaddingLeft = "1rem",
		contentLabelsMaxWidth,
		contentLabelsFlexWrap,
		contentLabelsTextWrap,
		contentWrapperMaxWidth,
		contentWrapperDisplay,
		contentWrapperFlexWrap,
		contentWrapperTextWrap,
	} = options;

	const headerCellHeight = headerHeight;

	return {
		header: label,
		size: width,
		width,
		minSize: width,
		maxSize: width,
		enableColumnFilter: false,
		enableSorting: false,
		enableColumnActions: false,
		muiTableHeadCellProps: {
			sx: {
				...(enableHeadFlex && {
					display: "flex",
					flexDirection: "column",
					justifyContent: "flex-end",
				}),
				maxWidth: width,
				minWidth: width,
				height: headerCellHeight,
				minHeight: headerCellHeight,
				maxHeight: headerCellHeight,
				px: 0.5,
				py: 2,
				overflow: "visible",
				"& .Mui-TableHeadCell-Content": {
					display: "flex",
					flexDirection: "column",
					alignItems: "flex-start",
					justifyContent: "flex-end",
					height: "100%",
					overflow: "visible",
				},
				"& .Mui-TableHeadCell-Content-Labels": {
					display: "flex",
					flexDirection: "column",
					alignItems: "flex-start",
					justifyContent: "flex-end",
					height: "100%",
					textWrap: contentLabelsTextWrap ?? "wrap",
					overflow: "visible",
					paddingLeft: contentLabelsPaddingLeft,
					...(contentLabelsMaxWidth && { maxWidth: contentLabelsMaxWidth }),
					...(contentLabelsFlexWrap && { flexWrap: contentLabelsFlexWrap }),
				},
				"& .Mui-TableHeadCell-Content-Wrapper": {
					...(contentWrapperDisplay && { display: contentWrapperDisplay }),
					transform: `rotate(${rotationAngle}deg)`,
					transformOrigin: "left bottom",
					fontSize: "0.75rem",
					fontWeight: 600,
					textTransform: "uppercase",
					letterSpacing: "0.03em",
					whiteSpace: "nowrap",
					...(contentWrapperMaxWidth && { maxWidth: contentWrapperMaxWidth }),
					...(contentWrapperFlexWrap && { flexWrap: contentWrapperFlexWrap }),
					...(contentWrapperTextWrap && { textWrap: contentWrapperTextWrap }),
					overflow: "visible",
				},
				...headSx,
			},
		},
		muiTableBodyCellProps: {
			sx: {
				maxWidth: width,
				minWidth: width,
				whiteSpace: "nowrap",
				overflow: "hidden",
				textOverflow: "ellipsis",
				...bodySx,
			},
		},
	};
};

